import React, { FC, CSSProperties } from 'react';

import styles from './Field.module.scss';
import { Field as FieldReact } from 'react-final-form';

export interface IField {
  label?: string | React.ReactNode;
  name: string;
  placeholder?: string;
  style?: CSSProperties;
  styleInput?: CSSProperties;
  className?: string;
  type?: string;
  onFocus?: () => void;
  onBlur?: (value: string) => void;
  disabled?: boolean;
  readonly?: boolean;
  onInput?: (value: string) => void;
  onChange?: () => void;
  value?: string | number;
  defaultValue?: string | number;
  autoComplete?: 'true' | 'false';
  tagRequired?: boolean
}

const hasError = (meta: any, disabled?: boolean) => (
  !disabled && meta.invalid && meta.touched
);

const FieldForm: FC<IField> = ({
  label, style, styleInput, className, name, defaultValue,
  type = 'text', placeholder, autoComplete,
  onFocus, onBlur, onInput, disabled, value, readonly,
  onChange, tagRequired
}) => {

  if (!placeholder && typeof (label) == 'string') {
    placeholder = label;
  }

  if (tagRequired && typeof (label) == 'string') {
    label = <>{label} <span style={{ color: 'red' }}>*</span></>;
  }

  return (
    <FieldReact name={name} type={type} defaultValue={defaultValue} initialValue={value}>
      {
        (props) => (
          <div className={`${styles['contentInput']} ${className ?? ''}`} style={style}>
            <label className={styles['description']}>{label}</label>
            <label
              hidden={type === 'hidden'}
              className={styles['labelInput']}>
              <input
                {...props.input}
                disabled={disabled}
                placeholder={placeholder}
                readOnly={readonly}
                style={styleInput}
                className={`${hasError(props.meta, disabled) && !props.meta.active ? styles['invalid'] : ''}`}
                onInput={(e: any) => onInput && onInput(e.target.value)}
                onChangeCapture={onChange}
                onBlur={(e: any) => onBlur && onBlur(e.target.value)}
                autoComplete={autoComplete ? autoComplete : 'true'}
              />
              {/* {props.meta.active ? onFocus && onFocus() : onBlur && onBlur()} */}
            </label>
            <div className={styles['errorInput']}>
              {hasError(props.meta, disabled) ? props.meta.error : ''}
            </div>
          </div>)
      }
    </FieldReact>
  );
};

export default FieldForm;
